// extracted by mini-css-extract-plugin
export default {"container":"header_container__6Yw-4","nav_ph":"header_nav_ph__5ED40","search":"header_search__Ibdry","form":"header_form__vwBsH"};